import React, { useState } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Select,
  Button,
  Checkbox,
  CheckboxGroup,
  Stack,
  Heading,
} from "@chakra-ui/react";

const JobSearch2 = () => {
  const [formValues, setFormValues] = useState({
    experience: "",
    locations: [],
    skills: [],
    titles: [],
    companies: [],
  });

  const handleChange = (field, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formValues);
  };

  return (
    <Box
      maxW="1000px"
      mx="auto"
      mt="10"
      p="6"
      borderWidth="1px"
      borderradius="md"
      boxShadow="lg"
    >
      <Heading as="h2" size="lg" mb="6" textAlign="center">
        Experience Form
      </Heading>
      <form onSubmit={handleSubmit}>
        <FormControl mb="4">
          <FormLabel>Experience (Years)</FormLabel>
          <Select
            placeholder="Select experience"
            value={formValues.experience}
            onChange={(e) => handleChange("experience", e.target.value)}
          >
            {Array.from({ length: 10 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </Select>
        </FormControl>

        <div className="flex gap-20">
          <FormControl mb="4">
            <FormLabel>Locations</FormLabel>
            <CheckboxGroup
              value={formValues.locations}
              onChange={(value) => handleChange("locations", value)}
            >
              <Stack spacing="2">
                {["New York", "San Francisco", "London", "Berlin", "Tokyo"].map(
                  (location) => (
                    <Checkbox key={location} value={location}>
                      {location}
                    </Checkbox>
                  )
                )}
              </Stack>
            </CheckboxGroup>
          </FormControl>

          <FormControl mb="4">
            <FormLabel>Skills</FormLabel>
            <CheckboxGroup
              value={formValues.skills}
              onChange={(value) => handleChange("skills", value)}
            >
              <Stack spacing="2">
                {["React", "Node.js", "Python", "Java", "C++"].map((skill) => (
                  <Checkbox key={skill} value={skill}>
                    {skill}
                  </Checkbox>
                ))}
              </Stack>
            </CheckboxGroup>
          </FormControl>

          <FormControl mb="4">
            <FormLabel>Titles</FormLabel>
            <CheckboxGroup
              value={formValues.titles}
              onChange={(value) => handleChange("titles", value)}
            >
              <Stack spacing="2">
                {[
                  "Software Engineer",
                  "Project Manager",
                  "Data Scientist",
                  "Designer",
                ].map((title) => (
                  <Checkbox key={title} value={title}>
                    {title}
                  </Checkbox>
                ))}
              </Stack>
            </CheckboxGroup>
          </FormControl>

          <FormControl mb="4">
            <FormLabel>Company</FormLabel>
            <CheckboxGroup
              value={formValues.companies}
              onChange={(value) => handleChange("companies", value)}
            >
              <Stack spacing="2">
                {["Google", "Amazon", "Microsoft", "Apple", "Netflix"].map(
                  (company) => (
                    <Checkbox key={company} value={company}>
                      {company}
                    </Checkbox>
                  )
                )}
              </Stack>
            </CheckboxGroup>
          </FormControl>
        </div>

        <Button colorScheme="blue" type="submit" width="full">
          Submit
        </Button>
      </form>
    </Box>
  );
};

export default JobSearch2;
